import { activateGeoIp } from '../../store/map/mapSlice'
import { renderPage } from '../../domain/address/addressHP.page'
import { requestMove } from '../../store/map/map.actions'
import { selectMapBbox } from '../../store/map/map.selectors'
import { resetSearchTerms } from '../../store/search/searchSlice'
import { loadHomePageData } from '../home/home.route'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ store: { dispatch, getState } }) => {
  return Promise.all([
    dispatch(activateGeoIp()),
    dispatch(resetSearchTerms()),
    requestMove({ bbox: selectMapBbox(getState()) })(dispatch, getState),
    loadHomePageData(dispatch, getState)
  ])
}

export default handleRouteLoading({ onRouteEnter, renderPage })
